import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import theme from './Theme';
import { initMixpanel } from "./utils/mixpanel";


import * as Sentry from "@sentry/react";

if (import.meta.env.VITE_ENVIRONMENT !== 'local') {
  Sentry.init({
    dsn: 'https://3655e8895c390a1a94aefe4707a2aa82@o4509479819083776.ingest.de.sentry.io/4509480132280400',
    // Setting this option to true will send default PII data to Sentry.
    // For example, automatic IP address collection on events
    sendDefaultPii: true,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.browserProfilingIntegration()
    ],
    // Tracing
    tracesSampleRate: 1.0, //  Capture 100% of the transactions
    // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: ['localhost', 'gurunow.ai'],
    profilesSampleRate: 1.0,

    environment: import.meta.env.VITE_ENVIRONMENT || 'dev',
  });
  if (import.meta.env.VITE_MIXPANEL_TOKEN) {
    initMixpanel();
  }
}

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
